import errors from './errors/index.js';
import translation from './translation/index.js';
const ru = {
    translation,
    errors,
};
export default Object.freeze(ru);
